import { AppData } from "@/src/constants/app-data";
import { Instagram, Facebook, Twitter } from "lucide-react";

export function FooterBrand() {
    return (
        <div className="space-y-6">
            <h2 className="text-white font-serif text-2xl tracking-widest uppercase font-light">
                {AppData["AppName"]}
            </h2>
            <p className="text-sm leading-relaxed font-light">
                Elevating the everyday through the art of scent. Handcrafted in
                our London studio.
            </p>
            <div className="flex gap-4">
                <Instagram
                    size={20}
                    className="hover:text-white cursor-pointer transition-colors"
                />
                <Facebook
                    size={20}
                    className="hover:text-white cursor-pointer transition-colors"
                />
                <Twitter
                    size={20}
                    className="hover:text-white cursor-pointer transition-colors"
                />
            </div>
        </div>
    );
}
